var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{on:{"navClicked":function($event){_vm.bodyComponent = $event}}}),_c('transition',{attrs:{"name":"slide","mode":"out-in","appear":""}},[_c(_vm.bodyComponent,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }